var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCard(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5E5E66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    id: 123,
    d: "M2 6.75C2 5.23122 3.23122 4 4.75 4H15.2505C16.7693 4 18.0005 5.23122 18.0005 6.75V8.61899V13.2515C18.0005 14.7703 16.7693 16.0015 15.2505 16.0015H4.75C3.23122 16.0015 2 14.7703 2 13.2515V8.61899V6.75ZM16.5005 6.75V7.86899H3.5V6.75C3.5 6.05964 4.05964 5.5 4.75 5.5H15.2505C15.9408 5.5 16.5005 6.05964 16.5005 6.75ZM16.5005 9.36899H3.5V13.2515C3.5 13.9419 4.05964 14.5015 4.75 14.5015H15.2505C15.9409 14.5015 16.5005 13.9419 16.5005 13.2515V9.36899ZM4.99927 12.1241C4.58505 12.1241 4.24927 12.4598 4.24927 12.8741C4.24927 13.2883 4.58505 13.6241 4.99927 13.6241H6.99927C7.41348 13.6241 7.74927 13.2883 7.74927 12.8741C7.74927 12.4598 7.41348 12.1241 6.99927 12.1241H4.99927Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.bfda37ae.svg";
export { ForwardRef as ReactComponent };